import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import WeeksConversionLeadTimeLabel from './WeeksConversionLeadTimeLabel';
import { leadTimeInDaysCutoff } from './leadTimeCalculator';

const BuildToOrderLeadTimeLabel = ({
  leadTimeDays,
  showConversionInBrackets,
}) => {
  if (leadTimeDays === null || leadTimeDays === undefined)
    return <Fragment>Call</Fragment>;
  else if (leadTimeDays === 0) return <Fragment>In Stock</Fragment>;
  else
    return (
      <Fragment>
        {(leadTimeDays <= leadTimeInDaysCutoff || showConversionInBrackets) && (
          <Fragment>
            {}
            {leadTimeDays > 1 ? `${leadTimeDays} business days` : 'Next day'}
          </Fragment>
        )}
        {showConversionInBrackets && leadTimeDays > leadTimeInDaysCutoff && (
          <Fragment>
            {' '}
            ({<WeeksConversionLeadTimeLabel leadTimeDays={leadTimeDays} />})
          </Fragment>
        )}
        {!showConversionInBrackets && leadTimeDays > leadTimeInDaysCutoff && (
          <WeeksConversionLeadTimeLabel
            leadTimeDays={leadTimeDays}
            roundToNearestWeek={true}
          />
        )}
      </Fragment>
    );
};

BuildToOrderLeadTimeLabel.propTypes = {
  leadTimeDays: PropTypes.number,
};

BuildToOrderLeadTimeLabel.defaultProps = {
  showConversionInBrackets: false,
};

export default BuildToOrderLeadTimeLabel;
